import selectLocalExercise from './selectLocalExercise';
const selectSolutionShown = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return false;
  }
  return localExercise.solutionShown;
};
export default selectSolutionShown;